import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from "recharts";
import {  LoanMonthData} from "@/data/loanData";

export default function RevenueChart({ rows }: { rows: LoanMonthData[] }) {
  const chartData = rows.map((d) => ({
    month: d.month.replace(" 2025", " '25").replace(" 2026", " '26"),
    revenue: d.revenue / 1_000_000,
    outstanding: d.outstanding / 1_000_000,
  }));

  return (
    <div className="rounded-lg border border-border bg-card p-5 shadow-sm">
      <h3 className="text-lg font-semibold text-card-foreground mb-1">Revenue & Outstanding</h3>
      <p className="text-sm text-muted-foreground mb-4">Monthly breakdown in millions</p>

      <ResponsiveContainer width="100%" height={280}>
        <BarChart data={chartData} margin={{ top: 5, right: 10, left: 0, bottom: 0 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(220, 13%, 90%)" />
          <XAxis dataKey="month" tick={{ fontSize: 11, fill: "hsl(220, 10%, 46%)" }} tickLine={false} axisLine={false} />
          <YAxis tick={{ fontSize: 11, fill: "hsl(220, 10%, 46%)" }} tickLine={false} axisLine={false} tickFormatter={(v) => `${v}M`} />
          <Tooltip
            contentStyle={{ backgroundColor: "hsl(0, 0%, 100%)", border: "1px solid hsl(220, 13%, 90%)", borderRadius: "8px", fontSize: 12 }}
            formatter={(value: number) => [`${value.toFixed(1)}M`, ""]}
          />
          <Bar dataKey="revenue" fill="hsl(173, 58%, 39%)" radius={[4, 4, 0, 0]} name="Revenue" />
          <Bar dataKey="outstanding" fill="hsl(43, 96%, 56%)" radius={[4, 4, 0, 0]} name="Outstanding" />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
